export default __webpack_public_path__ + "static/media/bgMain.fa8f2aa3.png";